import * as React from 'react';
import { MuiThemeProvider, Dialog, DialogContent, DialogContentText, Button, DialogActions } from '@material-ui/core';
import createMuiTheme, { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { connect, Dispatch } from 'react-redux';
import { bindActionCreators, ActionCreatorsMapObject } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router';
import Loading from './Loading';
import { AccountLogoutAsyncActionCreator, AccountLogoutActionCreator, accountLogoutAsync, errorCleared, ErrorClearedAction } from '../../actions';
import Routes from '../../routes/Routes';
import { StoreState } from '../../store';

//#region UI configuration
const strings = {
    okButton: 'Ok'
};

const componentTheme = createMuiTheme({
} as ThemeOptions);
//#endregion

//#region Props & State
interface AppStateProps {
    readonly error: Error | null;
}
interface AppDispatchProps {
    readonly logout: () => Promise<void>;
    readonly clearError: () => void;
}
interface AppProps extends RouteComponentProps<void>, AppStateProps, AppDispatchProps { }
interface AppState { }
//#endregion

class App extends React.Component<AppProps, AppState> {

    render() {
        const { error } = this.props;

        return (
            <MuiThemeProvider theme={componentTheme}>
                <Routes />
                <Loading />
                {error != null && <Dialog
                    open={error != null}
                    disableBackdropClick={true}
                    disableEscapeKeyDown={true}
                >
                    <DialogContent>
                        <DialogContentText>{error.message}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onDialogOkClick} autoFocus={true}>{strings.okButton}</Button>
                    </DialogActions>
                </Dialog>}
            </MuiThemeProvider>
        );
    }

    //#region Private
    private onDialogOkClick = () => {
        const { error } = this.props;
        if (error && error.name === '401') {
            this.props.logout();
        }
        this.props.clearError();
    }
    //#endregion
}

//#region Connect
interface DispatchAyncActionCreators extends ActionCreatorsMapObject {
    logout: AccountLogoutAsyncActionCreator;
    clearError: () => ErrorClearedAction;
}

interface DispatchActionCreators extends ActionCreatorsMapObject {
    logout: AccountLogoutActionCreator;
    clearError: () => ErrorClearedAction;
}

const mapStateToProps = (state: StoreState): AppStateProps => ({
    error: state.error
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => bindActionCreators<DispatchAyncActionCreators, DispatchActionCreators>(
    {
        logout: accountLogoutAsync,
        clearError: errorCleared
    },
    dispatch);

export default withRouter(connect<AppStateProps, AppDispatchProps>(mapStateToProps, mapDispatchToProps)(App));
//#endregion



// WEBPACK FOOTER //
// ./src/modules/app/App.tsx